import { createSlice } from "@reduxjs/toolkit";

const user = localStorage.getItem("$$") !== null ? JSON.parse(localStorage.getItem("$$")) : null;

const userSlice = createSlice({
    name: "user",
    initialState: user,
    reducers: {
        addUser: (_, action) => {
            action.payload.sAMAccountName[0] = action.payload.sAMAccountName[0].toLowerCase()
            localStorage.setItem("$$", JSON.stringify(action.payload));
            return action.payload;
        },
        removeUser: () => {
            localStorage.removeItem("$$");
            localStorage.removeItem("currentFileInfo");
            return null;
        }
    }
});

export const {addUser, removeUser} = userSlice.actions;
export default userSlice.reducer;
